<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('profile.label.investment_purposes')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <div class="col-md-6 offset-md-3">
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeShortTermFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeShortTermFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeShortTermFlg">
              {{ $t('profile.investment.purpose_short_term_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeLongTermFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeLongTermFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeLongTermFlg">
              {{ $t('profile.investment.purpose_long_term_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeExchangeFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeExchangeFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeExchangeFlg">
              {{ $t('profile.investment.purpose_exchange_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeSwapFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeSwapFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeSwapFlg">
              {{ $t('profile.investment.purpose_swap_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeHedgeAssetFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeHedgeAssetFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeHedgeAssetFlg">
              {{ $t('profile.investment.purpose_hedge_asset_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeHighIntFlg.$model"
                   true-value="1" false-value="0"
                   id="purposeHighIntFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeHighIntFlg">
              {{ $t('profile.investment.purpose_high_int_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   v-model="$v.input['amsCustomerDetail.investmentView'].purposeEconomicFlg.$model"
                   true-value="1"
                   false-value="0"
                   id="purposeEconomicFlg"
                   @change="handleForceNewEvent"
            />
            <label class="form-check-label" for="purposeEconomicFlg">
              {{ $t('profile.investment.purpose_economic_flg') }}
            </label>
          </div>
        </div>
        <div class=" error-messages ng-active"
             v-if="$v.input['amsCustomerDetail.investmentView'].$error || $v.input['amsCustomerDetail.investmentView'].$anyError">
          <div class="form-check">
            {{ $t('MSG_TRS_NAF_0004_param', {param1: $t('profile.label.investment_purposes')}) }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit"
                :type="this.getButtonType()">
          {{ $t('profile.button.submit') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {parentCheckboxRequiredValidation} from '@/common/helpers/validation'

export default {
  name: "UpdateFxInvestPurpose",
  props: {},
  data() {
    return {}
  },
  mixins: [formMixin, forceNewUtil],
  methods: {
  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.investmentView': {
          purposeShortTermFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeLongTermFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeExchangeFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeSwapFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeHedgeAssetFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeHighIntFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          },
          purposeEconomicFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.investmentView'])
          }
        },
      }
    }
  },
}
</script>

<style scoped>

</style>
